export default __webpack_public_path__ + "static/media/d.3e3032c2.jpg";